import store from '@/store'
import Cookies from 'js-cookie'

const isGuestUser = () => {
  const user = Cookies.get('user') ? JSON.parse(Cookies.get('user')) : null
  return !user || user.name === 'Guest'
}

const getStudentPermissions = () => store.getters['roles/studentPermissions'] || []
const getDirectPermissions = () => store.getters['roles/authUserPermissionsName'] || []
const getRolePermissions = () => store.getters['roles/authUserRolesPermissionsName'] || []

const getAggregatedPermissions = () => {
  const permissions = [
    ...getStudentPermissions(),
    ...getDirectPermissions(),
    ...getRolePermissions(),
  ]
  return [...new Set(permissions)]
}

const isPublicPermission = permission =>
  !permission || permission === 'public'

const hasPermission = permission => {
  if (permission === 'no-access') return false
  if (permission === 'guest') return isGuestUser()
  if (isPublicPermission(permission)) return true

  const permissions = getAggregatedPermissions()

  return permissions.includes(permission)
}

export default function Permission(permission) {
  if (Array.isArray(permission)) {
    return permission.every(perm => hasPermission(perm))
  }

  return hasPermission(permission)
}